import BaseService from "./BaseService";

export default class CarneService extends BaseService {

  constructor(self) {
    super(self);
  }

  ExtratoFinanceiroCompleto(parameters) {
    return this.ExecutaFetch("/api/Carne/ExtratoFinanceiroCompleto", "POST", parameters);
  }

  ExtratoFinanceiroDetalhe(parameters) {
    return this.ExecutaFetch("/api/Carne/ExtratoFinanceiroDetalhe", "POST", parameters);
  }

}